import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="16"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M3.90034 11.6665C3.71618 11.4608 3.40008 11.4433 3.19432 11.6274C2.98856 11.8116 2.97105 12.1277 3.15521 12.3335L3.90034 11.6665ZM13.5 8C13.5 11.0376 11.0376 13.5 7.99999 13.5V14.5C11.5898 14.5 14.5 11.5899 14.5 8H13.5ZM7.99999 2.5C11.0376 2.5 13.5 4.96243 13.5 8H14.5C14.5 4.41015 11.5898 1.5 7.99999 1.5V2.5ZM3.53193 4.79198C4.53119 3.4029 6.16014 2.5 7.99999 2.5V1.5C5.82479 1.5 3.89924 2.56896 2.72015 4.20802L3.53193 4.79198ZM7.99999 13.5C6.37112 13.5 4.90815 12.7925 3.90034 11.6665L3.15521 12.3335C4.34469 13.6624 6.07486 14.5 7.99999 14.5V13.5Z"
            fill="currentColor"
        />
        <path
            d="M3 2V4.5H5.5"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M8 6V9H10.5"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default Icon;
